import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { Spin } from 'antd'
import { useDebounce } from 'hooks/useDebounce'
import { UseEditFilenameModal } from '../../EditFilenameModal/hooks/useEditFilenameModal/types'
import { PhotoFilename } from '../PhotoFilenameContext/types'
import { usePhotoFilenameExampleQuery } from 'schema'
import { useProjectContext } from 'context/ProjectContext'

const ModalExample: React.FC<UseEditFilenameModal<PhotoFilename>> = ({
  state,
  templateItems,
  valid,
}) => {
  const { projectId } = useProjectContext()
  const [debouncedTemplateItems, debouncing] = useDebounce(templateItems, 1000)
  const { id } = state ?? {}
  const { data, loading } = usePhotoFilenameExampleQuery({
    ...DefaultQueryHookOptions,
    skip: !id || !valid || debouncing,
    variables: {
      input: {
        classTypeId: id!,
        templateItems: debouncedTemplateItems,
        projectId,
      },
    },
  })
  return (
    <CIMSFormItem label="Example" help={HelpMessage.Exports.Example}>
      <Spin size="small" spinning={debouncing || (loading ?? false)}>
        {data?.photoFilenameExample}
      </Spin>
    </CIMSFormItem>
  )
}

export default ModalExample
